import React, { useContext } from 'react';
import { Box, Image, Link } from '@honda-canada/design-system-react';

import FooterContext from '../service/FooterContext';
import themeStyles from '../Footer.styles';
import { getFooterGtmTags } from '../utils';

const SocialMediaContainer = themeStyles.apply(Box, 'SocialMediaContainer');
const SocialLink = themeStyles.apply(Link, 'SocialLink');

const SocialMediaLinks = ({ data, alignment, noPadding }) => {
  const { styles, maxSocialMediaIcons, socialMediaLinksGapDesktop } = useContext(FooterContext);
  const items = data?.items;
  return (
    <SocialMediaContainer
      alignment={alignment}
      noPadding={noPadding}
      rowGapDesktop={socialMediaLinksGapDesktop}
      data-testid="cy-social-media-icon-container"
    >
      {items?.slice(0, maxSocialMediaIcons)?.map(item => (
        <SocialLink
          data-testid="cy-social-media-icon"
          key={item?.itemId}
          {...item?.url}
          tabIndex={0}
          {...getFooterGtmTags(item?.itemDisplayName)}
        >
          <Image {...item?.logo} alt={item?.itemDisplayName} {...styles?.socialImages} />
        </SocialLink>
      ))}
    </SocialMediaContainer>
  );
};

export default SocialMediaLinks;
